import * as service from './services'
import to from 'await-to-js'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async getTiposUnidades ({dispatch, getters}, q) {
    const [error, response = { data: null }] = await to(service.getTipoUnidades(q))
    if (error) {
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/redeUnidade/index.js